import { NgModule, Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({
    name:'sanitiseUrl'
})
export class SanitiseUrlPipe implements PipeTransform{
    constructor(private sanitizer:DomSanitizer){}
    transform(value: any, ...args: any[]) {
        return  this.sanitizer.bypassSecurityTrustResourceUrl(value);
    }

}

@Pipe({
    name:'sanitiseHtml'
})
export class SanitiseHtmlPipe implements PipeTransform{
    constructor(private sanitizer:DomSanitizer){}
    transform(value: any, ...args: any[]) {
        return  this.sanitizer.bypassSecurityTrustHtml(value);
    }

}

@Pipe({
  name:'sanitiseTrustUrl'
})
export class SanitiseTrustUrlPipe implements PipeTransform{
  constructor(private sanitizer:DomSanitizer){}
  transform(value: any, ...args: any[]) {
      return  this.sanitizer.bypassSecurityTrustUrl(value);
  }

}

@NgModule({
    declarations: [SanitiseHtmlPipe,SanitiseUrlPipe,SanitiseTrustUrlPipe],
    exports:[SanitiseHtmlPipe,SanitiseUrlPipe,SanitiseTrustUrlPipe]
})
export class SanitiseModule{
    constructor(){

    }
}
